module.exports = require("applicationinsights-native-metrics");